import { get } from 'lodash'
export default class Personal {
	constructor (init = {}) {
		this.moderators = get(init, 'moderator') && Array.isArray(init.moderator) ? init.moderator : []
		this.organizators = get(init, 'organizer') && Array.isArray(init.organizer) ? init.organizer : []
		this.experts = get(init, 'expert') && Array.isArray(init.expert) ? init.expert : []
		this.volunteers = get(init, 'volunteer') && Array.isArray(init.volunteer) ? init.volunteer : []
	}

	get forSave () {
		return JSON.stringify({
			moderator: this.moderators,
			organizer: this.organizators,
			expert: this.experts,
			volunteer: this.volunteers
		})
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Event/Personal.js